import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tinymedic-patient-order.reducer';

export const TinymedicPatientOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tinymedicPatientOrderEntity = useAppSelector(state => state.tinymedicPatientOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tinymedicPatientOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.detail.title">TinymedicPatientOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.status">Status</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.status}</dd>
          <dt>
            <span id="orderType">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.orderType">Order Type</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.orderType}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.createdById">Created By Id</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.createdById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.tenant">Tenant</Translate>
          </dt>
          <dd>{tinymedicPatientOrderEntity.tenant ? tinymedicPatientOrderEntity.tenant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.patient">Patient</Translate>
          </dt>
          <dd>{tinymedicPatientOrderEntity.patient ? tinymedicPatientOrderEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrder.deliveryAddress">Delivery Address</Translate>
          </dt>
          <dd>{tinymedicPatientOrderEntity.deliveryAddress ? tinymedicPatientOrderEntity.deliveryAddress.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tinymedic-patient-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tinymedic-patient-order/${tinymedicPatientOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TinymedicPatientOrderDetail;
